import { createSlice } from "@reduxjs/toolkit";
import {
  getConfirmFlow,
  createConfirmFlow,
  deleteConfirmFlow,
  clearLocalActiveConfirmFlow
} from './actions';

const initialState = {
  confirmFlow: { id: '', updated_at: '' },
  loading: false
};

const slice = createSlice({
  name: 'confirmFlows',
  initialState,
  extraReducers(builder) {
    builder
      .addCase(getConfirmFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(getConfirmFlow.fulfilled, (state, action) => {
        const { confirm_flow } = action.payload;
        const confirmFlow = { ...state.confirmFlow, ...confirm_flow };
        
        state.loading = false;
        state.confirmFlow = confirmFlow;
      })
      .addCase(getConfirmFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(createConfirmFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(createConfirmFlow.fulfilled, (state, action) => {
        const { confirm_flow } = action.payload;
        
        state.loading = false;
        state.confirmFlow = confirm_flow;       
      })
      .addCase(createConfirmFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteConfirmFlow.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteConfirmFlow.fulfilled, (state, action) => {
        const { status } = action.payload;
        
        state.loading = false;
        if (status === 204) state.confirmFlow = initialState.confirmFlow;       
      })
      .addCase(deleteConfirmFlow.rejected, (state) => {
        state.loading = false;
      })
      .addCase(clearLocalActiveConfirmFlow, state => {
        state.confirmFlow = initialState.confirmFlow;
      })
  }
})

export default slice.reducer;